import axios from "axios";

const env = process.env.VUE_APP_ENV || 'development';
export const API_URL = env === 'production'
  ? process.env.VUE_APP_API_URL_PROD
  : process.env.VUE_APP_API_URL_DEV;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
